import { useSelector, useStore } from "react-redux";

// styles
import './toast.styles.scss';

// reducers
import { clear, selectToast } from "hyc-store/reducers/toast";

const Toast = () => {
    const store = useStore();
    const data = useSelector(selectToast);

    const handleClick = () => {
        store.dispatch(clear());
    }

    if (!data) {
        return null;
    }

    return (
        <div className={`notification is-toast ${data.className}`}>
            <button className="delete" onClick={handleClick}></button>
            {data.message}
        </div>
    );
};

export { Toast };
